<template>
    <div class="tab-pane active">
        <PmlPackage :show="showPackageForm" @close="showPackageForm = false"></PmlPackage>
        <PmlProduct :show="showProductForm" @close="showProductForm = false"></PmlProduct>
        <div class="modal_content p-15">
            <div class="row">
                <div class="col-md-12 t_right">
                    <button class="btn btn-default" @click.prevent="openProducts()">
                        <span class="btn-label">
                            <i class="fa fa-plus-circle"></i>
                        </span>
                        {{ $t('product') }}
                    </button>
                    <button class="btn btn_green" @click.prevent="openPackages()">
                        <span class="btn-label">
                            <i class="fa fa-plus-circle"></i>
                        </span>
                        {{ $t('package') }}
                    </button>
                </div>
            </div>
        </div>
        <table class="table table-striped table-bordered m-0">
            <thead>
                <tr>
                    <th>{{ $t('product') }}</th>
                    <th class="t_center">{{ $t('amount') }}</th>
                    <th class="t_center">{{ $t('unit_price') }}</th>
                    <th class="t_center">{{ $t('total') }}</th>
                    <th class="t_center w_100">{{ $t('actions') }}</th>
                </tr>
            </thead>
            <tbody>
                <PmlItem v-for="item in list" :key="item.id" :item="item"></PmlItem>
                <tr v-show="!list.length">
                    <td class="t_center" colspan="5"><i class="fa fa-exclamation-triangle"></i> {{ $t('no_records_found') }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
    import PmlItem from './Item.vue'
    import PmlPackage from './AddPackage.vue'
    import PmlProduct from './Form.vue'
    import TableFilters from 'utils/mixins/table-filters'
    import { mapGetters } from 'vuex'

    export default {
        name: 'QuotationProducts',
        mixins: [ TableFilters ],
        components: { PmlItem, PmlPackage, PmlProduct },
        data () {
            return {
                showProductForm: false,
                showPackageForm: false,
                listConfig: {
                    orderProp: 'id',
                    orderDir: 'asc'
                }
            }
        },
        computed: {
            ...mapGetters({
                'deal': 'getDealInfo',
                'quotations': 'getDealQuotations'
            }),
            quotation () {
                return this.quotations.find((item) => item.id === parseInt(this.$route.params.quotation)) || {}
            },
            records () {
                return this.quotation.products || []
            }
        },
        methods: {
            openProducts () {
                this.showProductForm = true
                this.showPackageForm = false
            },
            openPackages () {
                this.showProductForm = false
                this.showPackageForm = true
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/deals/components/show/quotations/edit/products/Main.vue